var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('AppParam',{attrs:{"prop":_vm.zParameterModel.name,"value":( _obj = {}, _obj[_vm.zParameterModel.name] = {value: _vm.fieldValue}, _obj ),"model":_vm.zParameterModel,"disabled":_vm.disabled,"onChange":function (ref) {
	var data = ref.data;

	return _vm.onValueChange(data ? data.value : null);
},"mappable":false,"autofocus":""}})}
var staticRenderFns = []

export { render, staticRenderFns }